import { Injectable, inject } from '@angular/core';
import { CanActivate, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavigationStore } from 'src/app/store/navigation/navigation.store';
 
@Injectable({
  providedIn: 'root',
})
export class FirstNavigationGuard implements CanActivate {
    currentUrl = '';
    private readonly navigationStore = inject(NavigationStore);
    
  constructor(private router: Router) {
    this.listenToRouterEvents();
  }

  listenToRouterEvents() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        console.log('Navigating to:', event.url);
        this.currentUrl = event.url;
      });
  }
  
 
  canActivate(): boolean {
    if(this.currentUrl === '') {
        this.navigationStore.setFirstNavigationToQuestionLibrary(false);
        this.navigationStore.setFirstNavigationToApplicants(false);
        this.navigationStore.setAdminRefreshed(true);
        this.navigationStore.setFirstNavigationToStudies(true);
    }
    const isFirstNavigationToStudies = !this.navigationStore.isFirstNavigationToStudies() && this.currentUrl === '/adminhome';
    const isFirstNavigationToQuestionLibrary = !this.navigationStore.isFirstNavigationToQuestionLibrary() && this.currentUrl === '/adminhome/QuestionLibrary';
    const isFirstNavigationToApplicants = !this.navigationStore.isFirstNavigationToApplicants() && this.currentUrl === '/adminhome/Participants';
 
    if(isFirstNavigationToStudies) {
        this.navigationStore.setFirstNavigationToStudies(true);
    }
    if(isFirstNavigationToQuestionLibrary) {
        this.navigationStore.setFirstNavigationToQuestionLibrary(true);
    }
    if(isFirstNavigationToApplicants) {
        this.navigationStore.setFirstNavigationToApplicants(true);
    }
    return true;
  }
}